import React from 'react';
import { Layout, Avatar, Dropdown, Button, Space } from 'antd';
import {
    UserOutlined,
    LogoutOutlined,
    SettingOutlined,
    DashboardOutlined
} from '@ant-design/icons';
import { useAuth } from '../../../features/auth/contexts/AuthContext';
import styles from './Header.module.css';

const { Header: AntHeader } = Layout;

export default function Header() {
    const { currentUser, logout } = useAuth();

    // Chuyển từ Menu component sang items array
    const userMenuItems = [
        {
            key: 'profile',
            icon: <UserOutlined />,
            label: (
                <div className={styles.userInfo}>
                    <div className={styles.userName}>
                        {currentUser?.displayName || 'User'}
                    </div>
                    <div className={styles.userEmail}>
                        {currentUser?.email}
                    </div>
                </div>
            )
        },
        {
            type: 'divider'
        },
        {
            type: 'divider'
        },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Đăng xuất',
            onClick: logout
        }
    ];

    return (
        <AntHeader className={styles.header}>
            <div className={styles.headerContent}>
                <div className={styles.logo}>
                    <Space>
                        <span className={styles.logoIcon}>💌</span>
                        <span className={styles.logoText}>Money Lover</span>
                    </Space>
                </div>

                <div className={styles.headerActions}>
                    <Dropdown
                        menu={{ items: userMenuItems }}
                        placement="bottomRight"
                        trigger={['click']}
                    >
                        <Button type="text" className={styles.userButton}>
                            <Space>
                                <Avatar
                                    src={currentUser?.photoURL}
                                    icon={<UserOutlined />}
                                    size="small"
                                />
                                <span className={styles.userName}>
                                    {currentUser?.displayName || 'User'}
                                </span>
                            </Space>
                        </Button>
                    </Dropdown>
                </div>
            </div>
        </AntHeader>
    );
}
